var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M0.00327269 4.99833L9 0L17.9918 5.05L9.00409 9.93333L0.00327269 4.99833ZM9.81818 11.3942V20L18 15.5317V6.92667L9.81818 11.3942ZM8.18182 11.3942L0 6.885V15.5317L8.18182 20V11.3942Z","fill":"#707070"}})}
var staticRenderFns = []

export { render, staticRenderFns }